const { GET_INCIDENT, ERROR_INCIDENT } = require('../Constants/incident.constants');

const initalState = {
    error: {
        code: '',
        message: ''
    },
    incidentData: {}
};

export default (state = initalState, action) => {
    switch (action.type) {
        case GET_INCIDENT:
            return {
                ...state,
                incidentData: action.data
            };
        case ERROR_INCIDENT:
            return {
                ...state,
                error: {
                    message: action.data,
                    code: action.code
                }
            };
        default:
            return state;
    }
};
